(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-gs-product]').forEach(root => {
      if (root.dataset.gsReady) return;
      root.dataset.gsReady = 'true';
      const image = root.querySelector('.gs-main-photo');
      const imageLink = root.querySelector('[data-gs-image-link]');
      const setImage = (src, full, alt) => {
        if (!image || !src) return;
        image.srcset = '';
        image.src = src;
        if (alt) image.alt = alt;
        imageLink.href = full || src;
      };
      root.querySelectorAll('[data-gs-thumbnail]').forEach(button => {
        button.addEventListener('click', () => {
          setImage(button.dataset.gsThumbnail, button.dataset.gsFull, button.dataset.gsAlt);
          root.querySelectorAll('[data-gs-thumbnail]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        });
      });
      const select = root.querySelector('[data-gs-variant]');
      const add = root.querySelector('[data-gs-add]');
      const availability = root.querySelector('[data-gs-availability]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        root.querySelector('[data-gs-price]').textContent = option.dataset.price;
        const compare = root.querySelector('[data-gs-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = option.dataset.sale !== 'true';
        add.disabled = !available;
        add.textContent = available ? add.dataset.addLabel : add.dataset.soldLabel;
        availability.textContent = available ? root.dataset.availableLabel : add.dataset.soldLabel;
        root.querySelector('[data-gs-payment]').hidden = !available;
        const qty = root.querySelector('#gs-quantity');
        qty.min = option.dataset.min || '1';
        qty.step = option.dataset.step || '1';
        qty.value = qty.min;
        if (option.dataset.max) qty.max = option.dataset.max; else qty.removeAttribute('max');
        setImage(option.dataset.image);
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.gs-header details[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.gs-header details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
})();
